module.exports = __webpack_public_path__ + "static/media/szcd.6ee70132.png";